import React from 'react';
import { Col, Input } from 'antd';
import classNames from 'classnames';

import { GroupPartName } from '../components/GroupPart';
import { WrapperSelect } from 'common/components';
import { WrapperIngredient } from '../facts-panel/overlay/WrapperIngredient';
import { changeBreakout } from './utils';

const RenderIngredients = ({
  title,
  ingredients,
  onClickIngredients,
  originIngredient,
  isSelected,
}) => {
  const ingredientsArray = ingredients ? ingredients : [];

  //* ticket 8533 - correct wrong format ingredients array from BE response
  const ingredientStatementFromArray = ingredientsArray?.join(', ');
  const value = changeBreakout(ingredientStatementFromArray);

  //* ticket 8533 - correct wrong format ingredients array overlay from BE response
  const originIngredientStatementFromArray = originIngredient?.join(', ');
  const reformattedIngredientList = changeBreakout(
    originIngredientStatementFromArray
  );

  return (
    <GroupPartName
      title={title}
      onClick={onClickIngredients}
      className={classNames({
        'ingredient-selected': isSelected,
      })}
    >
      <Col span={24}>
        <p className='title-section'>Ingredients Breakout</p>
        <WrapperIngredient
          type='breakout'
          value={value}
          originValue={reformattedIngredientList}
        >
          <WrapperSelect
            mode='tags'
            style={{ width: '100%', pointerEvents: 'none' }}
            placeholder='INGREDIENTS'
            name='ingredients'
            listItemHeight={10}
            listHeight={250}
            value={value}
          />
        </WrapperIngredient>
      </Col>
      <Col span={24}>
        <p className='title-section'>Ingredients Statement</p>
        <WrapperIngredient
          type='statement'
          value={value}
          originValue={reformattedIngredientList}
        >
          <Input.TextArea
            rows={5}
            maxLength={3000}
            value={value?.join(', ')}
            readOnly
            style={{ cursor: 'default' }}
          />
        </WrapperIngredient>
      </Col>
    </GroupPartName>
  );
};

export default RenderIngredients;
